export const mobilePageWidthThreshold = 599;
export const mobileNavigationPageWidthThreshold = 1024;